import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import { frontEnd } from "../../config/links";
import { Link, useHistory, useLocation } from "react-router-dom";

const Banner = () => {
  useEffect(() => {
    // Initialize AOS with settings to only animate once
    AOS.init({
      once: true, // This is the key setting - animations will only happen once
      mirror: false, // Don't mirror animations when scrolling back up
      duration: 800,
      offset: 100, // Controls when the animation triggers
      easing: "ease-out"
    });

    // Refresh AOS on component mount
    AOS.refresh();
  }, []);

  const history = useHistory();

  const handleTryForFreeClick = () => {
    // Similar to handleLoginClick, show the auth modal and navigate to login
    // setShowAuthModal(true);
    history.push(frontEnd.register);
  };

  return (
    <BannerContainer data-aos="zoom-in" data-aos-duration="1000">
      <ContentWrapper>
        <BlurEffect />
        <BannerImage
          src="/assets/home/banner-person.png"
          alt="Person thinking"
          data-aos="fade-right"
          data-aos-duration="800"
          data-aos-delay="200"
        />
        <TextContent
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="300"
        >
          Haven't decided yet?
          <br />
          Don't worry, try
          <span className="mobile-break">
            <br />
          </span>{" "}
          free access!
          <BannerVector
            src="/assets/home/banner-vector.png"
            alt="banner vector"
          />
        </TextContent>
      </ContentWrapper>
      <ButtonWrapper
        data-aos="fade-left"
        data-aos-duration="800"
        data-aos-delay="400"
      >
        <TryButton onClick={handleTryForFreeClick}>Try For Free</TryButton>
        <SmallText>No credit card is needed</SmallText>
      </ButtonWrapper>
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  background-color: #201c56;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  max-width: 1196px;
  width: calc(100% - 32px);
  margin: 0 16px;

  @media (min-width: 902px) {
    flex-direction: row;
    height: 194px;
    width: 100%;
    margin: 0 auto;
  }

  @media (max-width: 1200px) {
    margin: 0 16px;
    width: calc(100% - 32px);
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
  position: relative;

  @media (min-width: 769px) {
    flex-direction: row;
    margin-right: 50px;
    text-align: left;
  }
`;

const BlurEffect = styled.div`
  position: absolute;
  left: 0.33%;
  right: 77.26%;
  top: 12.37%;
  bottom: -50.52%;
  background: #a3bdff;
  opacity: 0.56;
  filter: blur(125px);
  z-index: 0;
`;

const TextContent = styled.div`
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 32px 0;
  position: relative;

  .mobile-break {
    display: none;
    @media (max-width: 768px) {
      display: inline;
    }
  }

  @media (min-width: 769px) {
    margin-left: 90px;
    font-size: 28px;
  }

  @media (max-width: 1200px) {
    margin-left: 20px;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  margin: 0 0 32px 0;

  @media (min-width: 769px) {
    margin: 0 0 0 0;
    max-width: 300px;
  }

  @media (max-width: 1200px) {
    max-width: 200px;
  }
`;

const TryButton = styled.button`
  background-color: #4628ff;
  color: white;
  border: none;
  padding: 12px 0px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  margin: 0 auto;
  display: block;
  width: 100%;

  @media (min-width: 769px) {
    width: 136px;
  }

  &:hover {
    background-color: #6d28d9;
  }
`;

const SmallText = styled.p`
  color: white;
  font-size: 16px;
  margin: 8px 0 0;
  text-align: center;
  font-weight: 400;
`;

const BannerImage = styled.img`
  width: 130px;
  height: 130px;
  margin: 0;
  position: relative;
  z-index: 1;

  @media (min-width: 769px) {
    width: 186px;
    height: 190px;
    margin-left: 75px;
  }

  @media (max-width: 1200px) {
    width: 120px;
    height: 120px;
    margin-left: 20px;
  }
`;

const BannerVector = styled.img`
  width: 210px;
  height: 17px;
  position: absolute;
  bottom: -5px;
  right: 0;

  @media (max-width: 769px) {
    right: 50px;
    width: 140px;
  }
`;

export default Banner;
